# frozen_string_literal: true

require_relative 'base'

module Engine
  module Action
    class ViewMergeOptions < Base
    end
  end
end
